import React from 'react';
import { useAddress2Step } from './useAddress2Step';
import { AuthAddress2StepView } from './AuthAddress2StepView';
import type { AddressData } from '../address1Step';

type AuthAddress2StepProps = {
    loading?: boolean;
    address: AddressData | undefined;
    onAddress2Submit: (city: string, state: string) => void;
    error?: string | null;
    dismissError?: () => void;
};

export const AuthAddress2Step: React.FC<AuthAddress2StepProps> = ({
    loading,
    address,
    onAddress2Submit,
    error,
    dismissError,
}) => {
    const { register, control, errors, onSubmit, isUS } = useAddress2Step(
        onAddress2Submit,
        address,
    );

    return (
        <AuthAddress2StepView
            register={register}
            control={control}
            errors={errors}
            loading={loading}
            isUS={isUS}
            onSubmit={onSubmit}
            error={error}
            dismissError={dismissError}
        />
    );
};
